var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3293 10.5234C24.1797 10.6359 21.5383 12.0785 21.5383 15.2863C21.5383 18.9967 24.8994 20.3093 25 20.3418C24.9845 20.4218 24.466 22.1395 23.2279 23.8897C22.1238 25.4298 20.9708 26.9675 19.2167 26.9675C17.4626 26.9675 17.0112 25.9799 14.9862 25.9799C13.0129 25.9799 12.3113 27 10.7068 27C9.10232 27 7.9828 25.5749 6.69561 23.8247C5.20464 21.7695 4 18.5767 4 15.5464C4 10.6859 7.26053 8.10811 10.4695 8.10811C12.1745 8.10811 13.5959 9.19322 14.6664 9.19322C15.6853 9.19322 17.2743 8.0431 19.2141 8.0431C19.9493 8.0431 22.5907 8.10811 24.3293 10.5234ZM18.2932 5.9854C19.0954 5.06281 19.6629 3.78268 19.6629 2.50255C19.6629 2.32503 19.6475 2.14501 19.6139 2C18.3087 2.0475 16.7558 2.84258 15.8194 3.89519C15.0843 4.70527 14.3981 5.9854 14.3981 7.28303C14.3981 7.47805 14.4316 7.67307 14.4471 7.73557C14.5297 7.75058 14.6638 7.76808 14.7979 7.76808C15.969 7.76808 17.442 7.008 18.2932 5.9854Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple_icon.e1f204e0c0facc43939454530dd090d1.svg";
export { ForwardRef as ReactComponent };